import { IContainer, injectContainer } from '../../interface/container';
import { IMediaAPI } from './media';
import { IAuthAPI } from './auth';
import { IMediaDiffAPI } from './mediaDiff';
import { ISiteDataAPI } from './siteData';

const TYPES = {
    IMediaAPI: Symbol.for('IMediaAPI'),
    IAuthAPI: Symbol.for('IAuthAPI'),
    IMediaDiffAPI: Symbol.for('IMediaDiffAPI'),
    ISiteDataAPI: Symbol.for('ISiteDataAPI'),
};

export function injectMediaAPI(container: IContainer = injectContainer()): IMediaAPI {
    return container.get<IMediaAPI>(TYPES.IMediaAPI);
}

export function bindMediaAPI(val: IMediaAPI, container: IContainer = injectContainer()) {
    return container.bind<IMediaAPI>(TYPES.IMediaAPI, val);
}

export function unbindMediaAPI(container: IContainer = injectContainer()) {
    return container.remove(TYPES.IMediaAPI);
}

export function injectAuthAPI(container: IContainer = injectContainer()): IAuthAPI {
    return container.get<IAuthAPI>(TYPES.IAuthAPI);
}

export function bindAuthAPI(val: IAuthAPI, container: IContainer = injectContainer()) {
    return container.bind<IAuthAPI>(TYPES.IAuthAPI, val);
}

export function unbindAuthAPI(container: IContainer = injectContainer()) {
    return container.remove(TYPES.IAuthAPI);
}

export function injectMediaDiffAPI(container: IContainer = injectContainer()): IMediaDiffAPI {
    return container.get<IMediaDiffAPI>(TYPES.IMediaDiffAPI);
}

export function bindMediaDiffAPI(val: IMediaDiffAPI, container: IContainer = injectContainer()) {
    return container.bind<IMediaDiffAPI>(TYPES.IMediaDiffAPI, val);
}

export function unbindMediaDiffAPI(container: IContainer = injectContainer()) {
    return container.remove(TYPES.IMediaDiffAPI);
}

export function injectSiteDataAPI(container: IContainer = injectContainer()): ISiteDataAPI {
    return container.get<ISiteDataAPI>(TYPES.ISiteDataAPI);
}

export function bindSiteDataAPI(val: ISiteDataAPI, container: IContainer = injectContainer()) {
    return container.bind<ISiteDataAPI>(TYPES.ISiteDataAPI, val);
}

export function unbindSiteDataAPI(container: IContainer = injectContainer()) {
    return container.remove(TYPES.ISiteDataAPI);
}
